import React from 'react';
import { islamicCalculators } from './ConstantsIslamicCalculator';
import SharedHelmet from '.././Helmet';
const TITLE = 'Calculatrices Zakat en ligne gratuites';
const DESCRIPTION =
  "Calculatrices Zakat en ligne gratuites pour effectuer vos calculs islamiques de facon claire et rapide. Outil pratique pour verifier vos donnees et obtenir un resultat fiable en ligne.";
const KEYWORDS =
  "s zakat s, calculatrice s zakat s, calcul en ligne, zakat, heritage, calcul islamique, resultat rapide";
const OG_URL = 'https://do-calculate.com/calculator/fr/islamic-calculators/';
function CalculatorsList() {
    return (
        <div className="container ltr-container">
            <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL}  />
            <div  >
                <h1 style={{ fontSize: '26px' }}>{TITLE}</h1>
                <hr />
                <div className="alert alert-secondary" role="alert">
                    <p>Consultez toutes les calculatrices de zakat en un seul endroit, avec une interface claire pour aller a l essentiel.</p>
                </div>
            </div>
            <hr/>
            <table >
                <thead>
                    <tr >
                        <th >Calculatrice</th>
                        <th >Description</th>
                    </tr>
                </thead>
                <tbody>
                    {islamicCalculators.map((calculator, index) => (
                        <tr key={index}>
                            <td>
                                <a href={calculator.link}> <h2 style={{ fontSize: '14px' }}>{calculator.name}</h2> </a>
                            </td>
                            <td><p>{calculator.description}</p></td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <br />
        </div>
    );
}
export default CalculatorsList;
